/*                                      */

/**
 *
 *
 */
export const VERSION = '5.39.8';
export const PUBLIC_VERSION = '5';
